const messages = {
  title: "Kainoraščiai ir produktų brošiūros",
  description:
    "Atsisiųskite naujausias brošiūras ir lankstinukus apie Bridgestone ir Firestone padangas lengviesiems automobiliams, SUV ir komerciniams transporto priemonėms.",
  brochureCategories: {
    products: "Produktai",
    brand_and_solutions: "Prekės ženklas ir sprendimai",
    season_and_promotions: "Sezonas ir akcijos",
    format: "Formatas",
    cars_and_vans: "Lengvasis automobilis, SUV, komercinis",
    summer: "Vasara",
    winter: "Žiema",
    promotions: "Akcijos",
    all_season: "Visasezonės",
    truck_and_buses: "Sunkvežimis ir autobusas",
    motorcycle: "Motociklas",
    agriculture: "Žemės ūkis",
    construction_machinery: "Statybinė technika",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Medžiagos",
    brochures: "Produktų brošiūros",
    price_list: "Kainoraščiai",
    materials: "Medžiagos",
    video_in_store: "Vaizdo įrašas su subtitrais",
    video_online: "Vaizdo įrašas be subtitrų",
    banner_website: "Baneris",
    banner_social_media: "Socialiniai tinklai",
    logos: "Logotipai",
  },
  searchMedia: "Įveskite raktinį žodį",
  searchResults: "Paieškos rezultatai",
};

export default {
  messages,
};
